import { render } from "./ButtonToolbar.vue?vue&type=template&id=6a5c87b0"
import script from "./ButtonToolbar.vue?vue&type=script&lang=js"
export * from "./ButtonToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__